import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "@/pages/Home";
import Generator from "@/pages/Generator";
import ModuloPro from "@/pages/ModuloPro";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Score from "@/pages/Score";
import Transparencia from "@/pages/Transparencia";
import Simulador from "@/pages/Simulador";
import MultaPublic from "@/pages/MultaPublic";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import PoliticaCookies from "@/pages/PoliticaCookies";
import EjercerDerechos from "@/pages/EjercerDerechos";
import Art14Ter from "@/pages/Art14Ter";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Cuenta from "@/pages/Cuenta";
import Onboarding from "@/pages/Onboarding";
import Guias from "@/pages/Guias";
import Admin from "@/pages/Admin";
import SobreNosotros from "@/pages/SobreNosotros";
import Contacto from "@/pages/Contacto";
import Casos from "@/pages/Casos";
import Header from "@/components/Header";
import SiteFooter from "@/components/SiteFooter";
import CookieConsent from "@/components/CookieConsent";
import PostHogLoader from "@/components/PostHogLoader";
import GoogleAnalyticsLoader from "@/components/GoogleAnalyticsLoader";
import ProtectedRoute from "@/components/ProtectedRoute";
import PageviewTracker from "@/components/PageviewTracker";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PageviewTracker />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/modulo-pro" element={<ModuloPro />} />
            <Route path="/generar" element={<ModuloPro />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/score/:slug" element={<Score />} />
            <Route path="/transparencia" element={<Transparencia />} />
            <Route path="/simulador-multas" element={<Simulador />} />
            <Route path="/multas/:slug" element={<MultaPublic />} />
            <Route path="/faq" element={<Navigate to="/#preguntas-frecuentes" replace />} />
            <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
            <Route path="/politica-cookies" element={<PoliticaCookies />} />
            <Route path="/ejercer-derechos" element={<EjercerDerechos />} />
            <Route path="/derechos-arco" element={<Navigate to="/ejercer-derechos" replace />} />
            <Route path="/cumplimiento-art-14-ter" element={<Art14Ter />} />
            <Route path="/sobre-nosotros" element={<SobreNosotros />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/casos" element={<Casos />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Register />} />
            <Route
              path="/cuenta"
              element={<ProtectedRoute><Cuenta /></ProtectedRoute>}
            />
            <Route
              path="/cuenta/generar"
              element={<ProtectedRoute><Generator /></ProtectedRoute>}
            />
            <Route
              path="/onboarding"
              element={<ProtectedRoute><Onboarding /></ProtectedRoute>}
            />
            <Route
              path="/guias"
              element={<ProtectedRoute requirePro><Guias /></ProtectedRoute>}
            />
            <Route
              path="/admin"
              element={<ProtectedRoute requireRole="superadmin"><Admin /></ProtectedRoute>}
            />
          </Routes>
          <SiteFooter />
          <CookieConsent />
          <PostHogLoader />
          <GoogleAnalyticsLoader />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
